import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import {FormButtons, renderers, validations} from '../../components'
import Moment from 'react-moment'
import * as rest from '../../services'
import {Field, reduxForm, reset} from 'redux-form'
import {useDispatch, useSelector} from 'react-redux'
import {showErrorToast, showSuccessToast} from '../../state/toasts'

const COMMENT_FORM_NAME = 'comment-form'
let CommentForm = ({handleSubmit, pristine, reset, submitting}) => {
    return (
        <form onSubmit={handleSubmit}>
            <Field
                component={renderers.renderTextArea}
                className="form-control"
                name="value"
                rows="5"
                validate={[validations.required]}
            />
            <FormButtons submitting={submitting} pristine={pristine} reset={reset}/>
        </form>
    )
}
CommentForm = reduxForm({
    form: COMMENT_FORM_NAME,
})(CommentForm)

export const CommentDelete = ({comment, onDelete}) => {
    const dispatch = useDispatch()
    let OnDeleteConfirm = function () {
        new rest.CommentService(comment.url)
            .makeDeleteRequest()
            .then(() => {
                dispatch(showSuccessToast('Success', 'Comment Deleted successfully'))
                onDelete(comment)
            })
            .catch((errors) => {
                dispatch(showErrorToast('Error', errors.response.data))
            })
    }
    return (
        <>
            <components.Confirm
                onConfirm={OnDeleteConfirm}
                body="Are you sure you want to delete this Comment?"
                confirmText="Confirm delete Comment"
                confirmBSStyle="danger"
                title="Confirm delete Comment"
            >
                <ReactBootstrap.Button
                    disabled={comment.is_deleted}
                    size="sm"
                    variant="danger"
                >
                    {components.ICONS.DELETE}
                </ReactBootstrap.Button>
            </components.Confirm>
        </>
    )
}

const Comment = ({ticket, comment, onTicketUpdate}) => {
    const {user} = useSelector((state) => state.auth)
    return (
        <div>
            <ReactBootstrap.Row>
                <ReactBootstrap.Col xs="12">
                    <ReactBootstrap.Row>
                        <ReactBootstrap.Col xs="10">
                            <p style={{wordWrap: 'break-word', fontSize: "12px"}} className="text-justify">
                                {comment.value}
                            </p>
                        </ReactBootstrap.Col>
                        {user && (user.role === 'SuperUser' || user.is_superuser || user.role === 'Privileged') &&
                            <><ReactBootstrap.Col className=" text-end" xs="2">
                                <CommentDelete comment={comment}
                                               onDelete={() => onTicketUpdate(
                                                   {
                                                       ...ticket,
                                                       comments: ticket.comments.filter(x => x.url !== comment.url)
                                                   }
                                               )}/></ReactBootstrap.Col></>
                        }
                    </ReactBootstrap.Row>
                </ReactBootstrap.Col>

                <ReactBootstrap.Col className={"text-end"} xs="12">
                    <strong style={{fontSize: "14px", display: "block"}}> {comment.created_by} </strong>
                    <sub>
                        <Moment format="DD-MM-YYYY hh:mm A" local>
                            {comment.created_at}
                        </Moment>
                        <strong style={{paddingLeft: "8px"}}>
                            <Moment fromNow>{comment.created_at}</Moment>
                        </strong>{' '}

                    </sub>
                </ReactBootstrap.Col>
            </ReactBootstrap.Row>
        </div>
    )
}

export const TicketComments = ({ticket, onTicketUpdate}) => {
    const dispatch = useDispatch()
    const createComments = (values) => {
        values.ticket = ticket.url
        new rest.CommentService()
            .makePostRequest(values)
            .then((response) => {
                onTicketUpdate({...ticket, comments: [response, ...ticket.comments]})
                dispatch(reset(COMMENT_FORM_NAME))
                dispatch(showSuccessToast('Success', 'Comment created successfully'))
            })
            .catch((errors) => {
                dispatch(showErrorToast('Error', errors.response.data))
            })
    }
    return (
        <div>
            <CommentForm onSubmit={createComments}/>
            <div className="mt-5">

                {ticket.comments.length ? (
                    <components.ItemList
                        itemRenderer={(index) => {
                            return (
                                <ReactBootstrap.Card key={ticket.comments[index].url}>
                                    <ReactBootstrap.Card.Body>
                                        <Comment
                                            ticket={ticket}
                                            comment={ticket.comments[index]}
                                            onTicketUpdate={onTicketUpdate}
                                        />
                                    </ReactBootstrap.Card.Body>
                                </ReactBootstrap.Card>
                            )
                        }}
                        length={ticket.comments.length}
                    />
                ) : (
                    <ReactBootstrap.Alert variant={'info'}>
                        No previous comments found.
                    </ReactBootstrap.Alert>
                )}

            </div>
        </div>
    )
}
